import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminPatrimoine = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Patrimoine & Actualités</h2>
        <small className="text-muted">
          Gérer le patrimoine et les actualités
        </small>
      </div>
      
      <SchemaManager
        schemaKey="patrimoine-actualites"
        endpoint="/api/patrimoine-actualites"
      />
    </div>
  );
};

export default AdminPatrimoine;